import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatStepper } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import {
  OrderService,
  OrderHistoryService,
  ProceedStepService,
  VoucherService,
} from '@app/api/api';
import { LayoutUtilsService } from '@app/core/_base/crud/utils/layout-utils.service';
import { saveAs } from 'file-saver';
import { environment } from 'environments/environment';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { AppCartModalChangeAddressComponent } from '../../app-cart-modal-change-address/app-cart-modal-change-address.component';
import { CdkStepper } from '@angular/cdk/stepper';
import { AppOrderDetailAddProductComponent } from '../app-order-detail-add-product/app-order-detail-add-product.component';
import { ModalUserCompanyInfoComponent } from '../modal-user-company-info/modal-user-company-info.component';
import $ from 'jquery';
import { UtilService } from '@app/services/util.service';
import { UnpaidOrderService } from 'app/api/unpaid-order.service';
@Component({
  selector: 'meu-app-order-detail',
  templateUrl: './app-order-detail.component.html',
  styleUrls: ['./app-order-detail.component.scss'],
  providers: [{ provide: CdkStepper }],
})
export class AppOrderDetailComponent implements OnInit {
  showMultiFileUpload = false;
  multiFileInvoiceList: { file: File; customName: string }[] = [];

  onMultiFileInvoice(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const allowedExtensions = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'txt', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'psd', 'ai'];

      const newFiles = Array.from(input.files)
        .filter((file) => {
          const parts = file.name.split('.');
          const extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
          if (!extension || !allowedExtensions.includes(extension)) {
            this.toastrService.error(
              `File "${file.name}" không hợp lệ. Chỉ chấp nhận: ${allowedExtensions.join(', ')}`,
              'Lỗi'
            );
            return false;
          }
          return true;
        })
        .map((file) => ({
          file: file,
          customName: file.name.replace(/\.[^/.]+$/, ''), // Bỏ extension để user dễ sửa
        }));

      this.multiFileInvoiceList = [...this.multiFileInvoiceList, ...newFiles];
      input.value = '';
    }
  }

  removeMultiFileInvoice(index: number) {
    this.multiFileInvoiceList.splice(index, 1);
  }

  async uploadMultiFileInvoice() {
    if (!this.orderId || this.multiFileInvoiceList.length === 0) return;
    const token = localStorage.getItem(environment.authTokenKey);
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    for (const item of this.multiFileInvoiceList) {
      const formData = new FormData();
      // Lấy extension từ file gốc
      const extension = item.file.name.split('.').pop();
      const finalName = item.customName + '.' + extension;
      formData.append('file', item.file, item.file.name);
      formData.append('name', finalName);

      await this.http
        .post(
          `${environment.backendhost}/api/orders/${this.orderId}/financialDocument/Upload`,
          formData,
          { headers }
        )
        .toPromise()
        .then(() => {
          this.toastrService.success(`Đã upload: ${finalName}`);
        })
        .catch((err) => {
          this.toastrService.error(`Lỗi upload: ${finalName}`);
        });
    }
    this.multiFileInvoiceList = [];
    this.showMultiFileUpload = false;
    this.getOrderById(this.orderId);
    this.getFinancialDocuments(this.orderId);
  }
  environment = environment;
  isAdminPage: boolean = false;
  stepSelected: any = {};
  subStepSelected: any = {};
  orderId;
  orderData: any = {};
  orderHistoryData: any = [];
  orderHistoryData$ = new Subject();
  proceedStep$ = new Subject();
  proceedStep = [];
  cancelStep: any = {};
  subStep$ = new Subject();
  backend = environment.backendhost;
  lstFile: any = [];
  fileInvoice: any = {};
  isHasNewInvoice: boolean = false;
  lstProductCart: any = [];
  financialDocuments: any[] = [];
  orderPayments: any[] = [];
  subStepForm = new FormGroup({
    order_id: new FormControl(),
    title: new FormControl(),
    content: new FormControl(),
    is_public: new FormControl(),
    is_sent_email_default: new FormControl(),
    step_id: new FormControl(),
  });
  activitySelected = null;

  vatValue = 0;

  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  //@ViewChild('proceed', { static: false }) proceed: ElementRef;
  constructor(
    private orderService: OrderService,
    private activatedRoute: ActivatedRoute,
    private orderHistoryService: OrderHistoryService,
    private proceedStepService: ProceedStepService,
    private toastrService: ToastrService,
    private layoutUtilsService: LayoutUtilsService,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private router: Router,
    private voucherService: VoucherService,
    private http: HttpClient,
    private unpaidOrderService: UnpaidOrderService
  ) {}
  ngOnChanges() {
    // const progress = this.elementRef.nativeElement.querySelector('.steps')
    // progress.style.setProperty("--index1", "red");
  }
  ngOnInit() {
    //this.proceed.nativeElement.style.setProperty('--index1','red');
    if (/admin/.test(window.location.href)) {
      this.isAdminPage = true;
    }
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      if (
        this.activatedRoute.snapshot.params.id !== null &&
        this.activatedRoute.snapshot.params.id !== ''
      ) {
        this.orderId = this.activatedRoute.snapshot.params.id;
        this.getOrderById(this.orderId);
        this.getOrderHistoryByOrderId(this.orderId);
        this.getOrderPayments(this.orderId);
      }
    });
    this.getAllProcessStep();
  }

  getOrderById(orderId) {
    this.voucher = '';
    this.isAppliedVoucher = false;
    this.orderService.apiOrdersIdGet(orderId).subscribe((res) => {
      if (res.success) {
        this.orderData = res.data;
        this.orderData.created_at = moment(this.orderData.created_at).format('DD/MM/YYYY');
        this.orderData.fulladdress =
          this.orderData.address +
          (this.orderData.ward ? ', phường ' + this.orderData.ward : '') +
          (this.orderData.district != null ? ', quận ' + this.orderData.district : '') +
          ', ' +
          this.orderData.province +
          (this.orderData.country ? ', ' + this.orderData.country : '');
        this.fileInvoice = this.orderData.invoice ? this.convertToJson(this.orderData.invoice) : '';
        this.lstProductCart = [...this.orderData.extend_order_products];
        this.getAllSubStepByStepId(this.orderData.step_id);

        if (this.orderData.voucher_code) {
          this.voucher = this.orderData.voucher_code;
          this.isAppliedVoucher = true;
        }

        if (this.orderData.vat) {
          const voucherVal = Number(this.orderData.voucher_value || this.orderData.voucherValue || 0);
          const baseAmount = this.orderData.total_no_vat - voucherVal;
          this.vatValue = baseAmount > 0 ? Math.round((this.orderData.vat * 100) / baseAmount) : 0;
        }

        this.changeDetectorRef.markForCheck();
      }
    });
    this.getFinancialDocuments(orderId);
  }

  getOrderPayments(orderId: string) {
    this.unpaidOrderService.getOrderPaymentsByOrder(orderId).subscribe(res => {
      if (res && res.success && res.data) {
        this.orderPayments = res.data.collection || [];
      } else {
        this.orderPayments = [];
      }
      this.changeDetectorRef.markForCheck();
    }, err => {
      this.orderPayments = [];
      this.changeDetectorRef.markForCheck();
    });
  }

  getFinancialDocuments(orderId: string) {
    const token = localStorage.getItem(environment.authTokenKey);
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    this.http
      .get<any>(`${environment.backendhost}/api/orders/${orderId}/financialDocument`, { headers })
      .subscribe(
        (res) => {
          if (res.success) {
            this.financialDocuments = res.data || [];
          } else {
            this.financialDocuments = [];
          }
          this.changeDetectorRef.markForCheck();
        },
        (err) => {
          this.financialDocuments = [];
          this.changeDetectorRef.markForCheck();
        }
      );
  }

  deleteFinancialDocument(doc: any) {
    const title = 'Xóa file';
    const description = `Bạn có chắc chắn muốn xóa file "${doc.name}"?`;
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      const token = localStorage.getItem(environment.authTokenKey);
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      this.http.delete<any>(`${environment.backendhost}/api/financialDocument/${doc.id}`, { headers }).subscribe(
        (result) => {
          if (result.success) {
            this.toastrService.success('Xóa file thành công', '');
            this.getFinancialDocuments(this.orderId);
          } else {
            this.toastrService.error(result.message || 'Xóa file thất bại', '');
          }
        },
        (err) => {
          this.toastrService.error('Xóa file thất bại', '');
        }
      );
    });
  }
  getAllProcessStep() {
    this.proceedStepService.apiProceedStepsGet('', 'sort_order').subscribe((res) => {
      if (res.success) {
        this.proceedStep = res.data.collection;
        this.setColorProceedStep(res.data.collection);
        //res.data.collection.find(x => { x.code == 'Cancel' ? this.cancelStep = x : {} });
        // let strColor="";
        // res.data.collection.forEach((item,i)=>{
        //   this.proceed.nativeElement.style.setProperty("--index"+ (i+1),item.color);
        //   strColor = strColor + item.color + ",";
        // })
        //this.proceed.nativeElement.style.setProperty("--step", "q,q,q,q");
        this.proceedStep$.next(res.data.collection);
      }
    });
  }
  setColorProceedStep(lstProceed) {
    for (let i = 0; i < lstProceed.length; i++) {
      $('.steps').append(`<style>
        #proceed${i} {background-color: ${lstProceed[i].color}}
        #proceed${i}::after {border-left-color: ${lstProceed[i].color}}


        #selected${i}{background-color: ${lstProceed[i].color}}
        #selected${i} span{font-weight: 600; text-decoration: underline;}
        #selected${i}::after {border-left-color: ${lstProceed[i].color} }
        </style>`);
    }
    this.changeDetectorRef.detectChanges();
  }
  getAllSubStepByStepId(stepId) {
    this.proceedStepService.apiProceedStepsStepIdProceedSubStepsGet(stepId).subscribe((res) => {
      if (res.success) {
        res.data.collection.push({ id: 'other', name: 'Khác' });
        this.subStepSelected = {};
        this.subStepForm.reset();
        this.lstFile = [];
        this.subStep$.next(res.data.collection);
      }
    });
  }

  getOrderHistoryByOrderId(orderId) {
    this.orderHistoryService.apiOrdersOrderIdOrderHistoriesGet(orderId).subscribe((res) => {
      if (res.success) {
        res.data.collection.forEach((item) => {
          item.created_at = moment(item.created_at).format('DD/MM/YYYY hh:mm');
        });
        this.orderHistoryData = res.data.collection;
        this.orderHistoryData$.next(res.data.collection);
      }
    });
  }
  deleteOrderHistory(historyId) {
    const title = 'Xóa trạng thái đơn hàng';
    const description = 'Bạn có chắc chắn muốn xóa?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.orderHistoryService.apiOrderHistoryIdDelete(historyId).subscribe((res) => {
        if (res.success == true) {
          this.getOrderHistoryByOrderId(this.orderId);
          this.toastrService.success('Xóa thành công', '');
        } else {
          this.toastrService.error(res.message, 'Xóa thất bại');
        }
        (error) => {
          this.toastrService.error('Xóa thất bại', '');
        };
      });
    });
  }
  //file
  onFileInput(ev) {
    const files = ev.target.files;
    if (files != undefined && files.length > 0) {
      const allowedExtensions = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'txt', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'psd', 'ai'];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const parts = file.name.split('.');
        const extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';

        if (!extension || !allowedExtensions.includes(extension)) {
          this.toastrService.error(
            `File "${file.name}" không hợp lệ. Chỉ chấp nhận: ${allowedExtensions.join(', ')}`,
            'Lỗi'
          );
          continue;
        }

        this.lstFile.push(file);
      }
      ev.target.value = '';
    }
  }
  onFileInvoice(ev) {
    const file = ev.target.files[0];
    if (file != undefined) {
      const allowedExtensions = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'txt', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'psd', 'ai'];
      const parts = file.name.split('.');
      const extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';

      if (!extension || !allowedExtensions.includes(extension)) {
        this.toastrService.error(
          `File "${file.name}" không hợp lệ. Chỉ chấp nhận: ${allowedExtensions.join(', ')}`,
          'Lỗi'
        );
        ev.target.value = '';
        return;
      }

      this.fileInvoice = file;
      this.isHasNewInvoice = true;
    }
  }

  getIconFile(file, isBackedFile) {
    let name;
    let typeName;
    if (isBackedFile) {
      file = JSON.parse(file);
      typeName = file.path.split('.').pop();
      name = file.name;
    } else {
      typeName = file.split('.').pop();
      name = this.getFileNameFromUrl(file);
    }
    if (typeName.includes('png') || typeName.includes('jpg') || typeName.includes('jpeg')) {
      return 'file-image.svg';
    }
    if (name.includes('doc') || name.includes('docx')) {
      return 'file-word.svg';
    }
    if (name.includes('xlsx')) {
      return 'file-excel.svg';
    }
    if (name.includes('pdf')) {
      return 'file-pdf.svg';
    }

    return 'file-other.svg';
  }
  deletefile(index) {
    this.lstFile.splice(index, 1);
  }
  selectStep(currentStep, i) {
    if (!this.isAdminPage) {
      return;
    }
    if (currentStep.id === this.stepSelected.id) {
      return (this.stepSelected = {});
    }
    this.stepSelected = currentStep;
  }
  dowloadFile(url) {
    if (url) {
      url = JSON.parse(url);
      let fileLink = this.backend + url.path;
      window.open(fileLink, '_blank');
    }
  }
  dowloadFileInvoice() {
    if (this.fileInvoice == '') {
      return this.toastrService.info('Vui lòng tải lên hóa đơn', '');
    }
    if (this.isHasNewInvoice) {
      return this.toastrService.info('Vui lòng lưu hóa đơn', '');
    }
    this.orderService.apiOrdersIdDownloadInvoiceGet(this.orderData.id).subscribe(
      (res) => {
        let invoiceDataEX = this.convertToJson(this.orderData.invoice).path.split('.').pop();
        let viewOnSiteEX = ['png', 'jpg', 'jpeg', 'pdf'];
        if (viewOnSiteEX.includes(invoiceDataEX)) {
          var fileURL = URL.createObjectURL(res);
          window.open(fileURL);
        } else {
          saveAs(res, this.convertToJson(this.orderData.invoice).name);
        }
      },
      (err) => {
        this.toastrService.error(err, 'Lỗi');
      }
    );
  }

  isPhoto(url) {
    url = JSON.parse(url);
    let extension = url.path.split('.').pop();
    let photoEx = ['jpg', 'png', 'tif', 'svg'];
    if (photoEx.includes(extension)) {
      return true;
    }
    return false;
  }
  getFileNameFromUrl(url) {
    return url.replace(/[\#\?].*$/, '');
  }
  convertToJson(object) {
    return JSON.parse(object);
  }
  changeActivity() {
    this.subStepForm.controls['is_sent_email_default'].setValue(
      this.subStepSelected.is_sent_email_default
        ? this.subStepSelected.is_sent_email_default
        : false
    );
    this.subStepForm.controls['is_public'].setValue(
      this.subStepSelected.is_public ? this.subStepSelected.is_public : false
    );
  }
  submitStepHistory() {
    if (this.subStepSelected.id != 'other') {
      this.subStepForm.controls['title'].setValue(this.subStepSelected.name);
    }
    this.subStepForm.controls['order_id'].setValue(this.orderId);
    this.subStepForm.controls['step_id'].setValue(this.orderData.step_id);
    this.orderHistoryService.apiOrderHistoriesPost(this.subStepForm.value).subscribe((res) => {
      if (res.success) {
        this.uploadFile(res.data.id).then(() => {
          this.subStepForm.reset();
          this.lstFile = [];
          this.getOrderHistoryByOrderId(this.orderId);
          //this.setColorProceedStep(this.proceedStep);
          this.toastrService.success('Thêm hoạt động thành công', '');
        });
      } else {
        this.toastrService.error(res.message, 'Thêm hoạt động không thành công');
      }
    });
  }
  updateStep(stepSelected) {
    if (!stepSelected.id) {
      return this.toastrService.info('Vui lòng chọn bước.', '');
    }
    if (stepSelected.id == this.orderData.step_id) {
      return this.toastrService.info('Vui lòng chọn bước khác.', '');
    }
    if (stepSelected.dependency_steps && stepSelected.dependency_steps.length > 0) {
      let condition = this.orderHistoryData.some((item) =>
        this.stepSelected.dependency_steps.includes(item.step_id)
      );
      if (!condition) {
        return this.toastrService.warning('Chưa đủ điều kiện để chuyển sang bước này.', '');
      }
    }
    let title, description, waitDesciption, dialogRef;
    if (stepSelected.id == this.cancelStep.id) {
      title = 'Hủy đơn hàng';
      description = 'Bạn có chắc chắn muốn hủy đơn hàng?';
      waitDesciption = 'Đang xử lý...';
      dialogRef = this.layoutUtilsService.updateElement(
        'Xác nhận',
        'warn',
        title,
        description,
        waitDesciption
      );
    } else {
      title = 'Chuyển trạng thái đơn hàng';
      description = 'Bạn có chắc chắn muốn chuyển?';
      waitDesciption = 'Đang xử lý...';
      dialogRef = this.layoutUtilsService.updateElement(
        'Xác nhận',
        'primary',
        title,
        description,
        waitDesciption
      );
    }
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.orderService
        .apiOrdersIdProceedStepPut(this.orderId, stepSelected.id)
        .subscribe((res) => {
          if (res.success) {
            this.orderData.extend_step_name = stepSelected.name;
            this.orderData.step_id = res.data.step_id;
            this.getAllSubStepByStepId(res.data.step_id);
            this.getOrderHistoryByOrderId(this.orderId);
            this.toastrService.success(title + ' thành công', '');
          } else {
            this.toastrService.error(res.message, title + ' không thành công', {
              timeOut: 300,
            });
          }
          (error) => {
            this.toastrService.error(res.message, title + ' không thành công');
          };
        });
    });
  }

  async uploadFile(idHistory) {
    for (let i = 0; i < this.lstFile.length; i++) {
      await this.orderHistoryService
        .apiOrderHistoriesIdAttachmentsPut(idHistory, this.lstFile[i])
        .toPromise()
        .then((res) => {
          if (res.success) {
          } else {
            this.toastrService.error(res.message, 'Tải lên không thành công');
          }
        });
    }
  }

  openModalChangeAddress() {
    var _this = this;
    const dialogRef = this.dialog.open(AppCartModalChangeAddressComponent, {
      data: {
        userId: this.orderData.user_id,
      },
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.event) {
        this.orderService
          .apiOrdersIdAddressAddressIdPut(this.orderId, res.addressID)
          .subscribe((result) => {
            if (result.success) {
              this.orderData.fullname = result.data.fullname;
              this.orderData.phone = result.data.phone;
              this.orderData.fulladdress =
                result.data.address +
                (result.data.ward ? ', phường ' + result.data.ward : '') +
                (result.data.district != null ? ', quận ' + result.data.district : '') +
                ', ' +
                result.data.province +
                (result.data.country ? ', ' + result.data.country : '');
              this.changeDetectorRef.markForCheck();
            }
          });
      }
    });
  }
  uploadFileInvoice() {
    this.orderService
      .apiOrdersIdUploadInvoicePut(this.orderId, this.fileInvoice)
      .subscribe((res) => {
        if (res.success) {
          this.isHasNewInvoice = false;
          this.orderData.invoice = res.data.invoice;
          this.toastrService.success('Lưu hóa đơn thành công', '');
        } else {
          this.toastrService.error(res.message, 'Lưu hóa đơn không thành công');
        }
      });
  }
  openModalAddProduct() {
    const dialogRef = this.dialog.open(AppOrderDetailAddProductComponent, {
      data: {
        orderId: this.orderData.id,
      },
      width: '1200px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.isAddProduct) {
        this.getOrderById(this.orderId);
      }
    });
  }
  deleteProductInOrder(orderProductId, index) {
    let title = 'Xóa sản phẩm';
    let description = 'Bạn có chắc chắn muốn xóa?';
    let waitDesciption = 'Đang xử lý...';
    let dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.orderService
        .apiOrdersOrderIDProductsOrderProductIdDelete(this.orderId, orderProductId)
        .subscribe((res) => {
          if (res.success) {
            //this.lstProductCart.splice(index, 1);
            this.getOrderById(this.orderId);
            this.toastrService.success('Xóa thành công', '');
          } else {
            this.toastrService.error(res.message, 'Xóa thất bại');
          }
          (error) => {
            this.toastrService.error(res.message, 'Xóa thất bại');
          };
        });
    });
  }
  updateQuantityProduct(type, i) {
    if (!this.isAdminPage) {
      return;
    }
    switch (type) {
      case 'plus':
        // code block
        this.lstProductCart[i].quantity++;
        break;
      case 'minus':
        // code block
        if (this.lstProductCart[i].quantity > 1) {
          this.lstProductCart[i].quantity--;
        }
        break;
    }
    this.orderService
      .apiOrdersOrderIDProductsOrderProductIdQuatityPut(
        this.orderId,
        this.orderData.order_product[i].id,
        this.lstProductCart[i].quantity
      )
      .subscribe((res) => {
        if (res.success) {
          this.getOrderById(this.orderId);
        } else {
          this.toastrService.error(res.message, 'Cập nhật không thành công', { timeOut: 300 });
        }
      });
  }
  routerLinkToProduct(productId, productName) {
    this.router.navigate([`/product/${productId}/${UtilService.slugify(productName)}/details`]);
  }

  /**
   * Voucher
   */
  voucher: any;
  isAppliedVoucher = false;
  voucherInfo: any;
  selectVoucher() {
    if (this.isAppliedVoucher) {
      return;
    }
    this.orderService.apiOrdersOrderIDVoucherPut(this.orderId, this.voucher).subscribe((res) => {
      if (res.success) {
        this.isAppliedVoucher = true;
        this.voucherInfo = res.data;
        this.getOrderById(this.orderId);
      } else {
        this.toastrService.error(res.message);
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  unSelectVoucher() {
    this.orderService
      .apiOrdersOrderIDRemoveAllVoucherDelete(this.orderId, this.voucher)
      .subscribe((res) => {
        if (res.success) {
          this.isAppliedVoucher = false;
          this.voucher = null;
          this.voucherInfo = null;
          this.getOrderById(this.orderId);
        } else {
          this.toastrService.error(res.message);
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  openModalCompanyInfo() {
    const dialogRef = this.dialog.open(ModalUserCompanyInfoComponent, {
      data: {
        userId: this.orderData.user_id,
        isAdminPage: this.isAdminPage,
      },
      width: '800px',
    });
  }

  downloadFinancialDocument(document: any) {
    if (!document || !document.id) {
      this.toastrService.error('Không tìm thấy thông tin file.');
      return;
    }
    const downloadUrl = `${environment.backendhost}/api/orders/${document.id}/downloadFinancial`;
    window.open(downloadUrl, '_blank');
  }
}
